<style src="@/assets/scss/general.scss" lang="scss"></style>

<template>
  <div id="app">
    <div id="wrapper">
      <router-view />
      <router-view name="mainMenu" v-if="!$route.meta.hideMainMenu" />
      <div
        id="page-wrapper"
        class="gray-bg"
        :class="{ 'no-margin': $route.meta.hideMainMenu }"
        v-if="!$route.meta.hideMainMenu"
      >
        <bread-crumps v-if="breadcrumb && !breadcrumb.hide" />

        <router-view name="mainContent" />
      </div>
    </div>
  </div>
</template>

<script>
import BreadCrumps from './components/breadcrumbs/Breadcrumbs';
import { mapGetters } from 'vuex';
import socket from './store/socket';
export default {
  components: { BreadCrumps },
  computed: {
    breadcrumb() {
      const path = this.$route.meta.breadcrumb;
      return path;
    },
    ...mapGetters({
      userToken: 'DATA-ACCESS/getUserToken',
      client: 'DATA-ACCESS/client',
    }),
    permissionConsumerMessages() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'consumer-message',
        'SHOW',
      );
    },
  },
  mounted() {
    // setInterval(() => this.checkOpened(), 5000)
  },
  methods: {
    async checkOpened() {
      const payload = {
        type: 'ler',
      };

      const opts = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      };
      try {
        const ret = await fetch(
          `https://peaceparking.app:3000/abertura/`,
          opts,
        );
        const data = await ret.json();
        const isOpened = data.isOpened;
        if (isOpened) {
          this.$toasted.error('Parquímetro 1 violado');
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
  watch: {
    userToken: {
      handler() {
        if (this.userToken) {
          const room = `sgi-${this.client._id}`;
          const auth = { userToken: this.userToken, room };
          if (this.permissionConsumerMessages) {
            auth.consumerRoom = 'consumer';
          }
          socket.auth = auth;
          socket.connect();
          socket.userToken = this.userToken;
          this.$socket = socket;
        }
      },
      immediate: true,
    },
  },
};
</script>
